import React from 'react';
import lodash from 'lodash';
import LoadingGif from '../images/Loading.gif';

class InfiniteScroll extends React.Component {
  constructor(props) {
    super();

    const {
      pageSize,
      pageStart,
      loadMore,
      loading,
      children,
      active,
      hasMore,
      paused,
      mode,
      containerRef,
      hasContainerRef,
      defaultLoading,
      loadWhenSpaceLeft
    } = props;

    this.state = {
      active: active || true,
      pageSize,
      pageStart,
      loadMore,
      loading,
      children,
      mode,
      hasMore,
      paused,
      defaultLoading: defaultLoading === undefined ? true : defaultLoading,
      currentPage: pageStart,
      hasContainerRef,
      containerRef,
      loadWhenSpaceLeft:
        loadWhenSpaceLeft === undefined ? true : loadWhenSpaceLeft
    };

    this.debouncedCallback = lodash.debounce(() => {
      if (
        !this.state.active ||
        this.state.paused ||
        this.state.loading ||
        !this.state.hasMore
      ) {
        return;
      }

      if (this.state.hasContainerRef && !this.state.containerRef) {
        return;
      }

      const condition = this.getCondition();

      if (condition) {
        this.reload();
      }
    }, 100);

    if (this.state.containerRef) {
      this.state.containerRef.addEventListener(
        'scroll',
        this.debouncedCallback
      );
    } else if (!this.state.hasContainerRef) {
      window.addEventListener('scroll', this.debouncedCallback);
    }
  }

  componentDidMount() {
    const condition = this.getCondition();
    if ((condition && this.state.loadWhenSpaceLeft) || this.props.loadOnMount) {
      this.reload();
    }
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.hasContainerRef &&
      prevProps.containerRef !== this.props.containerRef
    ) {
      this.setState(
        {
          containerRef: this.props.containerRef
        },
        () => {
          if (this.state.containerRef) {
            this.state.containerRef.addEventListener(
              'scroll',
              this.debouncedCallback
            );
            const condition = this.getCondition();

            if (condition && !this.props.loadOnMount) {
              this.reload();
            }
          }
        }
      );
    }

    if (prevProps.loading !== this.props.loading) {
      this.setState({ loading: this.props.loading });
    }

    if (prevProps.hasMore !== this.props.hasMore) {
      this.setState(state => ({
        ...state,
        hasMore: this.props.hasMore
      }));
    }

    if (prevProps.active !== this.props.active) {
      this.setState(state => ({
        ...state,
        active: this.props.active,
        currentPage: this.props.pageStart
      }));
    }

    if (prevProps.mode !== this.props.mode) {
      this.setState(state => ({
        ...state,
        currentPage: state.pageStart
      }));
    }

    if (prevProps.paused !== this.props.paused) {
      this.setState({ paused: this.props.paused });
    }

    if (prevProps.retryCount !== this.props.retryCount) {
      this.setState(state => ({ currentPage: state.currentPage - 1 }));
    }
  }

  componentWillUnmount() {
    if (this.state.hasContainerRef && this.state.containerRef) {
      this.state.containerRef.removeEventListener(
        'scroll',
        this.debouncedCallback
      );
    } else if (!this.state.hasContainerRef) {
      window.removeEventListener('scroll', this.debouncedCallback);
    }
  }

  getCondition = () => {
    let condition =
      window.innerHeight + document.documentElement.scrollTop >=
      document.documentElement.offsetHeight -
        document.documentElement.offsetHeight * 0.5;

    if (this.state.hasContainerRef && this.state.containerRef) {
      condition =
        this.state.containerRef.clientHeight +
          this.state.containerRef.scrollTop >=
        this.state.containerRef.scrollHeight -
          this.state.containerRef.scrollHeight * 0.5;
    }

    return condition;
  };

  reload = () => {
    if (this.props.paused || this.props.loading || !this.props.hasMore) {
      return;
    }

    this.state.loadMore(this.state.currentPage);
    this.setState(state => ({
      ...state,
      currentPage: state.currentPage + 1
    }));
  };

  render() {
    return (
      <>
        {this.props.children}
        {this.state.hasMore &&
          this.state.loading &&
          !this.state.paused &&
          this.state.active &&
          this.state.defaultLoading && (
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: '100%'
              }}
            >
              <img
                style={{ margin: '32px 0 32px 0' }}
                alt="loading"
                src={LoadingGif}
              />
            </div>
          )}
      </>
    );
  }
}

export default InfiniteScroll;
